<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-account"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <v-col>
            <div class="text-h2 font-weight-light">
              {{ 'customer_card - in development' }}
            </div>
          </v-col>
        </template>
        <div class="graphGrid">
          <div class="graphContainer">Graf 1</div>
          <div class="graphContainer" v-if="numberoflabels !== 0">
            <chartist
              :data="chartData"
              type="Bar"
              :options="{
                axisY: {
                  onlyInteger: true,

                },
                chartPadding: 30,
                distributeSeries: true
              }"
            />
          </div>
        </div>
        <div class="active_Campaign_info"></div>
        <div class="infoGrid">
          <div class="infoContainer">
            <p class="infoHeader">Operation</p>
            <p v-if="no_pickup_procedure">Ingen afhentnings procedure er lavet</p>
            <div class="box">
              <p>Afhentningsforhold:</p>
              <v-select
                v-model="item.pickup_method"
                dense
                :items="[
                  { text: $t('Jeg skal bruge en liste af ting der kan stå her'), value: 'invoice' },
                ]"
              />
            </div>
            <div class="box">
              <p style="margin-top: 20px;">Emballage:</p>
              <div class="flex">
                <v-switch
                  readonly
                  :value="item.packaging.includes('cages')"
                  dense
                  :label="`${'Burer'}`"
                />
                <v-switch
                  readonly
                  :value="item.packaging.includes('pallets')"
                  dense
                  :label="`${'Paller'}`"
                />
                <v-switch
                  readonly
                  :value="item.packaging.includes('bags')"
                  dense
                  :label="`${'Poser'}`"
                />
              </div>
            </div>
            <div class="box">
              <p style="margin-top: 20px;">Afhentning:</p>
              <p style="margin-top: 20px;" >{{item.pickup_time}}</p>
            </div>
            <div class="box">
              <p style="margin-top: 20px;">Skal bilen have lift?:</p>
              <div class="flex">
                <v-switch
                  readonly
                  v-model="item.lift"
                  dense
                  :label="`${item.lift ? 'Ja' : 'Nej'}`"
                />
              </div>
            </div>
            <div class="box" style="margin-top: 10px;">
              <p style="margin-top: 10px;">Hvem henter?:</p>
              <div class="flex">
                <v-text-field
                  readonly
                  v-model="item.linehaul_name"
                  dense
                />
              </div>
            </div>
            <div class="box">
              <p style="margin-top: 20px;" @click="getPallets()">Pallescan?:</p>
              <div class="flex">
                <v-switch
                  readonly
                  v-model="item.pallet_scan"
                  dense
                  :label="`${item.pallet_scan ? 'Ja' : 'Nej'}`"
                />
              </div>
            </div>
          </div>
          <div class="infoContainer">
            <p class="infoHeader">Generelle forhold</p>
            <div class="box">
              <p style="margin-top: 20px;">Norge:</p>
              <div class="flex">
                <v-checkbox
                  readonly
                  style=""
                  v-model="item.norway.invoice"
                  dense
                  :label="`${'Samlefaktura (KGH/Colorline)'}`"
                />
                <v-checkbox
                  readonly
                  style=""
                  v-model="item.norway.voec"
                  dense
                  :label="`${'VOEC (Stenaline)'}`"
                />
              </div>
            </div>
            <div class="box">
              <p style="margin-top: 20px;">UK:</p>
              <div class="flex">
                <v-checkbox
                  readonly
                  style=""
                  v-model="item.uk.eori"
                  dense
                  :label="`${'EORI'}`"
                />
                <v-checkbox
                  readonly
                  style=""
                  v-model="item.uk.vat"
                  dense
                  :label="`${'VAT'}`"
                />
              </div>
            </div>
            <div class="box">
              <p style="margin-top: 20px;">Sortering:</p>
              <div class="flex">
                <v-checkbox
                  style=""
                  readonly
                  v-model="item.sorting.yes"
                  dense
                  :label="`${'Ja'}`"
                />
                <v-checkbox
                  style=""
                  readonly
                  v-model="item.sorting.no"
                  dense
                  :label="`${'Nej'}`"
                />
                <v-checkbox
                  style=""
                  readonly
                  v-model="item.sorting.partialy"
                  dense
                  :label="`${'Delvist'}`"
                />
              </div>
            </div>
            <div class="box">
              <p>PCN:</p>
              <v-select
                v-model="item.pcn"
                readonly
                dense
                :items="[
                  { text: 'Pakke center nord', value: 'pcn' },
                  { text: 'Andet pakkecenter', value: 'apc' },
                ]"
              />
            </div>
            <div class="box">
              <p style="margin-top: 20px;">Returservice:</p>
              <div class="flex">
                <v-checkbox
                  style=""
                  readonly
                  v-model="item.return.kystvejen"
                  dense
                  :label="`${'Kystvejen'}`"
                />
                <v-checkbox
                  style=""
                  readonly
                  v-model="item.return.customer"
                  dense
                  :label="`${'Direkte til kunde'}`"
                />
              </div>
            </div>
          </div>
        </div>
        <iframe style="margin-top: 30px; border-radius: 6px;" :src="graphURL" height="600" width="100%"></iframe>
        <div class="BSContainer">
          <p class="infoHeader">Business Solution Support: Claims</p>
          <div class="bsblock">
            <div class="Casesblok">
              <p class="title_number">Totale sager</p>
              <p class="number">{{item.claimStats.done + item.claimStats.not_done}}</p>
            </div>
            <div class="Casesblok">
              <p class="title_number">Åbne sager</p>
              <p class="number">{{item.claimStats.not_done}}</p>
            </div>
            <div class="Casesblok">
              <p class="title_number">Lukkede sager</p>
              <p class="number">{{item.claimStats.done}}</p>
            </div>
          </div>
        </div>
      </base-material-card>
    </v-col>
  </v-row>
</template>

<script>
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import cronstrue from 'cronstrue/i18n';
export default {
  name: 'Card',
  data () {
    return {
      name: 'Card',
      availableOptions: [],
      customerOptions: [],
      procedures: [],
      cronValue: '',
      no_pickup_procedure: true,
      numberoflabels: 1,
      item: {
        pickup_method: 'invoice',
        packaging: [],
        pickup_time: '',
        lift: false,
        claimStats: {
          done: 0,
          not_done: 0,
        },
        pallet_scan: true,
        linehaul_name: 'Palle Pallesen Fragtmand',
        markets: ['DK'],
        carriers: ['DHL', 'UPS'],
        pcn: 'pcn',
        return: {
          customer: false,
          kystvejen: true,
        },
        norway: {
          invoice: false,
          voec: false,
        },
        uk: {
          eori: false,
          vat: false,
        },
        sorting: {
          yes: true,
          no: false,
          partialy: false,
        },
      },
      timeMenu: false,
    }
  },
  computed: {
    graphURL () {
      return `https://search-new-prod-yt4lonfddfmlqnvn6rsdi5gdgm.eu-central-1.es.amazonaws.com/_plugin/kibana/app/dashboards#/view/ee34adf0-ddbd-11ec-9a53-150a59afce36?embed=true&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1y,to:now))&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'852cbbe0-e8b8-11eb-bde5-299cb1ab7118',key:customer_id,negate:!f,params:(query:'${this.$route.params.id}'),type:phrase),query:(match_phrase:(customer_id:'${this.$route.params.id}')))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),panels:!((embeddableConfig:(),gridData:(h:15,i:'00a96261-51f9-45d1-aced-54ae13326aa9',w:24,x:0,y:0),id:bc6955a0-ddbd-11ec-8fb1-6fb07d2de518,panelIndex:'00a96261-51f9-45d1-aced-54ae13326aa9',type:visualization,version:'7.10.2'),(embeddableConfig:(),gridData:(h:15,i:'7ed79e4e-502f-4378-ada1-91337db4fd08',w:24,x:24,y:0),id:'2cbba4c0-f5b6-11eb-8828-ab1e7465a9d5',panelIndex:'7ed79e4e-502f-4378-ada1-91337db4fd08',type:visualization,version:'7.10.2')),query:(language:kuery,query:''),timeRestore:!f,title:'Customer%20id%20carrier',viewMode:edit)&show-time-filter=true`
    },
    chart_options: function () {
      return {
        axisY: {
          onlyInteger: true,
        },
        chartPadding: 30,
        stackBars: true,
        plugins: [ChartistTooltip({class: 'Tooltipclass',})],
      }
    },
    chartData: function () {
      let number = this.numberoflabels
      return {
        labels: [this.$t('Forsendelser ift aftale'), this.$t('Forsendelser år-til-dato')],
        series: Object.values({ promise: 10000, sent: number }),
      }
    }
  },
  mounted: function () {
    this.getClaimStats();
    this.getPallets();
    this.getProcedures();
    this.getNumberOfShipments();
  },
  methods: {
    getProcedures: function () {
        return this.$get(`/procedures/${this.$route.params.id}`)
          .then(response => {
            this.procedures = response.data.data;
            if (response.data.data.some(item => item.type === 'pickup_invoice')) {
              this.no_pickup_procedure = false;
            }
            this.procedures.forEach(el => {
              if (el.type == 'pickup_invoice') {
                this.item.linehaul_name = el.options.pickup_driver
                this.translateCron(el.options.cron.raw)
                this.item.lift = el.options.lift
                this.item.packaging = el.options.packaging
              }
            });
          })
          .catch(e => {
          })
    },
    translateCron: function (cron) {
      this.item.pickup_time = cronstrue.toString(cron, { locale: "da" })
    },
    getNumberOfShipments: function () {
      let date = this.$moment().format('YYYY-MM-DD')
      this.$get(`/shippinglabels?limit=20&page=1&order_by=created_at&order_dir=desc&filters%5Bcustomer_id%5D%5Bfrom%5D=${this.$route.params.id}&filters%5Bcustomer_id%5D%5Bto%5D=${this.$route.params.id}&filters%5Bcreated_at%5D%5Bfrom%5D=2022-01-01&filters%5Bcreated_at%5D%5Bto%5D=${date}`).then(response => {
        this.numberoflabels = response.data.total
      });
    },
    getPallets () {
      this.$get(`https://pallets.coolrunner.dk/panel/users/exists/25`).then(response => {
      });
    },
    getClaimStats: function () {
      this.$get(`/claims/statistics/${this.$route.params.id}`).then(response => {
        this.item.claimStats = response.data;
      });
      Promise.all([this.$get(`/customers/${this.$route.params.id}/options`), this.$get('/customer/options')]).then((values) => {
          this.customerOptions = [...values[0].data]
          this.availableOptions = values[1].data.data
          this.customerOptions.forEach(element => {
              switch (element.key) {
                case 'gb_vat':
                  if (element.value) {
                    this.item.uk.vat = true
                  }
                  break;
                case 'eori_number':
                  if (element.value) {
                    this.item.uk.eori = true
                  }
                case 'voec':
                  if (element.value) {
                    this.item.norway.voec = true
                  }
                case 'consolidated_invoice':
                  if (element.value === '1') {
                    this.item.norway.invoice = true
                  }
                default:
                  return
            }
          });
        })
    },
    allowedMinutes: v => v == 15 || v == 30 || v == 45 || v == 0
  }
}
</script>

<style lang="scss">
.graphGrid {
  display: grid;
  grid-template-columns:  2fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 30px;
  .graphContainer {
    text-align: center;
    border: 1px solid #d1d5db;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    .ct-bar{
      stroke-width: 40px;
    }
  }
}
.infoGrid {
  display: grid;
  grid-template-columns: 1fr 1fr ;
  grid-template-rows: 1fr;
  grid-gap: 20px;
  .infoContainer {
    padding: 20px 40px;
    text-align: center;
    border: 1px solid #d1d5db;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    .infoHeader {
      font-size: 20px;
      font-weight: bold;
      color: #6b7280;
    }
    .box {
      display: grid;
      text-align: left;
      grid-template-columns: 1fr 2fr;
      width: 100%;
      p {
        margin-right: 30px;
        margin-top: 10px;
      }
      .flex {
        display: flex;
        justify-content: space-between;
        align-items: right;
      }
    }
  }
}
.BSContainer {
  padding: 20px 40px;
  margin-top: 20px;
  text-align: center;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  .bsblock {
    display: flex;
    max-width: 500px;
    margin: 0 auto;
    justify-content: space-between;
    .Casesblok {
      .title_number {
        font-size: 18px;
        font-weight: bold;
        color: black;
      }
      .number {
        font-size: 40px;
        font-weight: bold;
        color: black;
      }
    }
  }
}
.chartist-tooltip{
  background-color: #fff !important;
  position: relative;
}
.chartist-tooltip:before{
  border-top-color: #fff !important;
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  width: 0;
  height: 0;
  margin-left: -15px;
  border: 15px solid transparent;
}
.Tooltipclass {
  background-color: #fff !important;
  border-radius: 6px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
